import {useEffect, useState} from 'react';

import {PHONE_MAX_WIDTH} from 'styles/ResponsiveConstants';

const PHONE_MEDIA_QUERY = `(max-width: ${PHONE_MAX_WIDTH}px)`;

export function getIsPhoneWidth(): boolean {
  return window.matchMedia(PHONE_MEDIA_QUERY).matches;
}

/**
 * Track if the window/screen is phone-sized, useful for situations where we have
 * a specialized mobile view.
 *
 * In many cases it's better to use media queries in CSS/Aphrodite rather than
 * this hook, but this hook is useful when render needs to make more dynamic
 * decisions.
 */
export default function useIsPhoneWidth(): boolean {
  const [isPhoneWidth, setIsPhoneWidth] = useState(getIsPhoneWidth());
  useEffect(() => {
    const mediaQuery = window.matchMedia(PHONE_MEDIA_QUERY);
    function handleChange(e: MediaQueryListEvent): void {
      setIsPhoneWidth(e.matches);
    }
    mediaQuery.addEventListener('change', handleChange);
    return () => {
      mediaQuery.removeEventListener('change', handleChange);
    };
  }, []);
  return isPhoneWidth;
}
